import { render } from "./GradientBlock.vue?vue&type=template&id=243d8e0e&ts=true"
import script from "./GradientBlock.vue?vue&type=script&lang=ts"
export * from "./GradientBlock.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__